import { useState } from "react";

import { AUTH_TOKEN_STORAGE } from "../constants/localStorageKeys";
import { safeStorage } from "../utils/storage";

export function useToken() {
  const [token, setStoredToken] = useState(() => {
    const token = safeStorage.getItem(AUTH_TOKEN_STORAGE);

    if (token) {
      safeStorage.setItem(AUTH_TOKEN_STORAGE, token);
    }

    return token;
  });

  const setToken = (token: string) => {
    safeStorage.setItem(AUTH_TOKEN_STORAGE, JSON.stringify(token));
    setStoredToken(token);
  };

  return { token, setToken };
}
